<template>
  <section
    v-if="selectedCard && !loadingEmbeddedViews"
    :aria-labelledby="selectedCard.display_name"
    class="h-screen"
  >
    <h1 class="page-header" :id="selectedCard.display_name">{{ selectedCard.display_name.toLowerCase() }}</h1>
    <div class="rounded-xl bg-gray-100 p-4 w-full h-full">
      <iframe
        frameborder="0"
        marginheight="0"
        marginwidth="0"
        title="Data Visualization"
        allowtransparency="true"
        allowfullscreen="true"
        class="w-full h-full"
        :src="selectedCard.url"
        :tabs="options.tabs"
        :toolbar="options.toolbar"
        :subscriptions="options.subscriptions"
        :load-order="options.loadOrder"
        :tooltip="options.tooltip"
      />
    </div>
  </section>
</template>


<script>
import { mapGetters } from 'vuex';
import RemoveRailsLoadingMixin from '../../mixins/RemoveRailsLoadingMixin';
import UserAbilitiesMixin from '../../mixins/UserAbilitiesMixin';
import config from '../../config/config';
import {merchantsAPI} from "../../services/api";

const InsightCards = [
  {
    id: 1,
    display_name: 'Campaign Performance',
    dashboard: 'CampaignPerformanceDashboard',
    tableau: 'MonthlyCampaignPerformance',
  },
  {
    id: 2,
    display_name: 'Loyalty',
    dashboard: 'LoyaltyDashboard',
    tableau: 'PointsAnalysis',
  },
  {
    id: 3,
    display_name: 'Member List Analysis',
    dashboard: 'MemberListAnalysis',
    tableau: 'SpendAnalysis',
  },
  {
    id: 4,
    display_name: 'Retail Sales',
    dashboard: 'RetailSalesDashboard',
    tableau: 'SalesAnalysis',
  }
]

export default {
  name: 'InsightReport',

  mixins: [RemoveRailsLoadingMixin, UserAbilitiesMixin],

  data() {
    return {
      selectedCard: null,
      loadingEmbeddedViews: false,
      options: {
        tabs: 'yes',
        toolbar: 'yes',
        subscriptions: 'no',
        loadOrder: '',
        tooltip: 'no',
      }
    }
  },

  created() {
    this.$store.dispatch('LOAD_CURRENT_MERCHANT').then(() => {
      this.removeLoading('campaign-show-loading-icon')
    })
    this.$store.dispatch('LOAD_CURRENT_USER');
    this.getEmbeddedView();
  },

  methods: {
    async getEmbeddedView() {
      this.loadingEmbeddedViews = true;

      try {
        const response = await merchantsAPI.getEmbeddedView(this.$route.params.id);
        if (response) {
          this.selectedCard = response
        }
        return this.selectedCard
      } catch (error) {
        this.error.message = "error, please refresh or contact support";
      } finally {
        this.loadingEmbeddedViews = false;
      }
    }
  },

  computed: {
    ...mapGetters(
      ['userAbilitiesValue', 'currentMerchant']
    ),
  },
}
</script>
